import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const onPortal = window.location.pathname.startsWith("/portal");
  const token = (onPortal && localStorage.getItem("fp_portal_token")) || localStorage.getItem("fp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const detail = err.response?.data?.detail;
    if (Array.isArray(detail)) {
      const field = String(detail[0]?.loc?.slice(-1)[0] || "");
      err.response.data.detail = field === "email" ? "E-mail inválido. Use o formato nome@dominio.com" : `Dados inválidos${field ? `: ${field}` : ""}`;
    }
    if (err.response?.status === 401) {
      // don't force logout on portal endpoints
      const url = err.config?.url || "";
      if (!url.includes("/portal/")) {
        localStorage.removeItem("fp_token");
        localStorage.removeItem("fp_user");
      }
    }
    return Promise.reject(err);
  }
);

export default api;
